import React from 'react';
import { AppBar } from 'react-admin';
import ProfileMenu from '../profile-menu/ProfileMenu.tsx';

const Appbar = props => <AppBar {...props} userMenu={<ProfileMenu />} />;
export default Appbar;